// src/utilities/localize.ts
import { LocalizeController as DefaultLocalizationController } from "@shoelace-style/localize";
import { registerTranslation } from "@shoelace-style/localize";
var LocalizeController = class extends DefaultLocalizationController {
};

export {
  LocalizeController,
  registerTranslation
};
